import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var zoomInIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.564 22.69-7.31-7.308c1.528-1.855 2.4-4.364 1.964-7.091-.545-4.036-3.927-7.2-7.854-7.636C4.69 0-.218 4.909.436 10.582c.437 4.036 3.6 7.309 7.637 7.854 2.727.437 5.236-.436 7.09-1.963l6.546 6.545a1.053 1.053 0 0 0 1.527 0l.328-.327ZM9.382 17.019c-4.037 0-7.418-3.273-7.418-7.309s3.272-7.418 7.418-7.418c4.145 0 7.418 3.273 7.418 7.418 0 4.146-3.382 7.31-7.418 7.31Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.836 8.836v.546a.978.978 0 0 1-.981.982h-3.6v4.581H9.6a.978.978 0 0 1-.982-.981v-3.6H4.036v-.546c0-.545.437-.982.982-.982h3.6V4.255h.546c.545 0 .981.436.981.981v3.6h4.691Z",
  fill: "currentColor",
  fillRule: "nonzero"
})));

export { zoomInIcon as default };
//# sourceMappingURL=zoomInIcon.js.map
